import React from 'react';
import { Input, Textarea, Checkbox } from '@leadsnavi/ui-kit';
// import { ChevronDown } from 'lucide-react';
import CountrySelect from '@/common/base/country-select';
import InputSelect from '@/common/base/input-select';
import { BuyerProfile } from './types';

interface BuyerProfileSectionProps {
  buyerProfile: BuyerProfile;
  onChange: (profile: BuyerProfile) => void;
  isCollapsed: boolean;
  onToggleCollapse: (collapsed: boolean) => void;
  errors: Record<string, string>;
}

// Industry options (frontend mock data)
const INDUSTRY_OPTIONS = [
  'Textiles & Apparel',
  'Bags, Footwear & Accessories',
  'Jewelry, Eyewear & Watches',
  'Beauty',
  'Personal Care',
  'Sports & Entertainment',
  'Parents, Kids & Toys',
  'Pet Products',
  'Gifts & Crafts',
  'School & Office Supplies',
  'Home & Garden',
  'Furniture & Home Furnishings',
  'Home Appliances',
  'Lighting',
  'Packaging',
  'Industrial Machinery',
  'Commercial Equipment & Machinery',
  'Automation & Robotics Equipment',
  'Tools & Hardware',
  'Construction & Building Materials',
  'Consumer Electronics',
  'Electronic Components',
  'Electrical Equipment',
  'Batteries & Energy Storage Systems',
  'Renewable Energy',
  'Automotive Parts & Accessories',
  'Vehicles & Transportation',
  'Health & Medical',
  'Agriculture, Food & Beverage',
  'Chemicals & Materials',
  'OEM / Contract Manufacturing',
  'Others',
];

const BuyerProfileSection: React.FC<BuyerProfileSectionProps> = ({
  buyerProfile,
  onChange,
  // isCollapsed,
  // onToggleCollapse,
  errors,
}) => {
  const inputBaseClass =
    'border-[#D4D4D4] rounded-[8px] medium-lg shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] placeholder:text-[#A3A3A3]';
  const labelClass = 'block text-sm font-medium text-[#171717] mb-1';

  return (
    <div className=" rounded-b-lg overflow-hidden ">
      {/* Header */}
      {/* <div
        className={`flex items-center justify-between py-4 transition-colors ${
          isCollapsed ? 'border border-[#E5E5E5] rounded-lg mt-5 px-5 mx-5 cursor-pointer' : 'px-5'
        }`}
        onClick={() => isCollapsed && onToggleCollapse(false)}
      >
        <h3 className="text-xl font-semibold text-[#171717] leading-tight">Edit Buyer Profile</h3>
        {isCollapsed && <ChevronDown className="h-5 w-5 text-[#A3A3A3]" />}
      </div> */}

      {/* Content */}
      {/* {!isCollapsed && ( */}
      <div className="flex flex-col gap-6 px-5 pb-7">
        <div className="grid grid-cols-2 gap-6">
          {/* Name */}
          <div className="flex flex-col gap-1">
            <label className={labelClass}>
              Name<span className="text-red-500 ml-1">*</span>
            </label>
            <Input
              value={buyerProfile.name}
              onChange={e => onChange({ ...buyerProfile, name: e.target.value })}
              placeholder="Alex Chen"
              maxLength={100}
              className={`${inputBaseClass} ${errors.name ? 'border-red-500' : ''}`}
            />
            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
          </div>

          {/* Location */}
          <div className="flex flex-col gap-1">
            <label className={labelClass}>
              Location<span className="text-red-500 ml-1">*</span>
            </label>
            <CountrySelect
              value={buyerProfile.location || null}
              onChange={value => {
                onChange({ ...buyerProfile, location: value as string });
              }}
              size="smallMedium"
              placeholder="e.g., United States"
              valueMode="name"
              className={`${errors.location ? 'border-red-500' : ''}  border-[#D4D4D4] rounded-[8px]`}
              aria-invalid={!!errors.location}
            />
            {errors.location && <p className="text-red-500 text-xs mt-1">{errors.location}</p>}
          </div>

          {/* Company Name */}
          <div className="flex flex-col gap-1">
            <label className={labelClass}>
              Company Name<span className="text-red-500 ml-1">*</span>
            </label>
            <Input
              value={buyerProfile.companyName}
              onChange={e => onChange({ ...buyerProfile, companyName: e.target.value })}
              placeholder="Company Name"
              maxLength={200}
              className={`${inputBaseClass} ${errors.companyName ? 'border-red-500' : ''}`}
            />
            {errors.companyName && <p className="text-red-500 text-xs mt-1">{errors.companyName}</p>}
          </div>

          {/* Industry */}
          <div className="flex flex-col gap-1">
            <label className={labelClass}>Industry</label>
            <InputSelect
              value={buyerProfile.industry || ''}
              options={INDUSTRY_OPTIONS}
              onChange={value => onChange({ ...buyerProfile, industry: value })}
              placeholder="e.g., Automotive"
              className={inputBaseClass}
              error={!!errors.industry}
            />
            {errors.industry && <p className="text-red-500 text-xs mt-1">{errors.industry}</p>}
          </div>
        </div>

        {/* Company Introduction */}
        <div className="flex flex-col gap-1">
          <label className={labelClass}>Company Introduction</label>
          <Textarea
            value={buyerProfile.companyIntroduction}
            onChange={e => onChange({ ...buyerProfile, companyIntroduction: e.target.value })}
            placeholder="Scalability, sourcing power, etc."
            rows={3}
            maxLength={1000}
            className={inputBaseClass}
          />
        </div>

        {/* Update my profile checkbox */}
        <div className="flex items-center gap-2">
          <Checkbox
            checked={buyerProfile.updateMyProfile}
            onCheckedChange={checked => onChange({ ...buyerProfile, updateMyProfile: checked === true })}
            id="update-profile"
          />
          <label htmlFor="update-profile" className="text-sm text-[#171717] cursor-pointer">
            Update my profile
          </label>
        </div>
      </div>
      {/* )} */}
    </div>
  );
};

export default BuyerProfileSection;
